











import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { ContentPriceSubject, ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import PaymentManager from "@/payments";
import { PurchaseResponse } from "@/payments/types";
import { EVENTS } from "@/const";
import UnlockFeedView from "./components/UnlockFeedView.vue";

@Component({
  name: "UnlockFeed",
  components: { UnlockFeedView },
})
export default class UnlockFeed extends mixins(WithAuthUser) {
  public loading = false;

  public selectedFeed: ContentFeed | null = null;

  public paymentPackages: PaymentPackage[] = [];

  public paymentSystemsPublic: PaymentSystemPublic[] = [];

  public purchaseProcessing = false;

  public async handleOneTimePurchase(selectedFeed: ContentFeed | undefined) {
    try {
      if (!selectedFeed) return;
      this.purchaseProcessing = true;
      const data: ContentPriceSubject = {
        subjectId: selectedFeed.id,
        subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
      };
      const cost = this.paymentPackages
        .find(p => p.id === selectedFeed.pricePackageId)
        ?.costs?.find(c => c.currency === getMainCurrencyCode())?.cost;
      const price = (cost && formatMoneyString(cost, { currencyCode: getMainCurrencyCode() })) || undefined;
      const response: PurchaseResponse = await PaymentManager.purchase({
        pricePackageId: selectedFeed.pricePackageId,
        price,
        subject: {
          subjectId: selectedFeed.id,
          subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
        },
      });
      if (response.status && !response.subjectPurchased) {
        await providers.ContentPriceProvider.purchase({ data });
      }
      emitter.emit(EVENTS.CONTENT_FEED_PURCHASED, { userId: selectedFeed.userId, feedId: selectedFeed.id });
      this.selectedFeed = null;
    } finally {
      this.purchaseProcessing = false;
    }
  }

  public async showUnlockFeed(contentFeed: ContentFeed) {
    if (this.loading) return;
    try {
      this.loading = true;
      await Promise.all([
        providers.PaymentSystemsProvider.findAllPublic({
          data: { subject: { subjectId: contentFeed.id, subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET } },
        }).then(r => (this.paymentSystemsPublic = r)),
        providers.PaymentPackageProvider.findAll({ type: [PaymentPackageEnum.FILESET] }).then(
          r => (this.paymentPackages = r)
        ),
      ]);
      this.selectedFeed = contentFeed;
    } finally {
      this.loading = false;
    }
  }

  public handleClose() {
    this.selectedFeed = null;
  }

  public created() {
    emitter.on<any>(EVENTS.CONTENT_FEED_PURCHASE, this.showUnlockFeed);
  }

  public destroyed() {
    emitter.off<any>(EVENTS.CONTENT_FEED_PURCHASE, this.showUnlockFeed);
  }
}
